module.exports = __webpack_public_path__ + "console/img/申通.dc3dbdd3.jpg";